import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetAllVideosInterface {
  search: string;
}

export const useGetAllVideos = () => {
  const mutate = useMutation(({ search }: GetAllVideosInterface) => {
    return get(`/enterprise-media-api/get_all_allocated_videos/${search}`);
  });

  return mutate;
};

export default useGetAllVideos;
